import { combineReducers } from "@reduxjs/toolkit";

import { default as commissions } from "./commissions";
import { default as confirmation } from "./confirmation";
import { default as currencySelection } from "./currencySelection";
import { default as priceRequest } from "./priceRequest";
import { default as sparepartAssembly } from "./sparepartAssembly";

export default combineReducers({
  commissions,
  priceRequest,
  confirmation,
  sparepartAssembly,
  currencySelection
});
